import { Link } from 'react-router-dom';

const steps = [
  {
    number: '01',
    title: '준비 항목 선택',
    description: '예복·예물·한복 중 준비 중인 항목을 골라요.',
  },
  {
    number: '02',
    title: '질문에 답하기',
    description: '답할 때마다 플래너 피드백이 바로 따라와요.',
  },
  {
    number: '03',
    title: '기준 리포트와 업체 추천',
    description: '정리된 기준에 맞는 인증업체로 바로 이어져요.',
  },
];

const options = [
  {
    id: 'rarely',
    label: '거의 안 입어요',
  },
  {
    id: 'occasionally',
    label: '가끔 경조사 때만',
  },
  {
    id: 'business',
    label: '비즈니스 자리에서 자주',
  },
  {
    id: 'daily',
    label: '데일리예요',
  },
];

const selectedOptionId = 'business';
const selectedFeedback = '정장에 익숙하시면 맞춤이 잘 맞을 가능성이 높아요. 핏과 원단을 더 꼼꼼히 비교해보면 좋아요.';

function QuestionPreviewCard() {
  return (
    <div className="mb-5 rounded-2xl border border-[rgba(112,115,124,0.22)] bg-white p-5 shadow-[0_1px_4px_rgba(23,23,23,0.06),0_4px_12px_rgba(23,23,23,0.07)] md:mb-0 md:rounded-[20px] md:p-7">
      <div className="mb-3.5 flex items-center justify-between md:mb-5">
        <span className="text-[11px] font-semibold tracking-[0.0252em] text-[rgba(46,47,51,0.61)] md:text-[12px]">
          예복 기준 찾기 · 미리보기
        </span>
        <span className="rounded-full bg-[#FBF1ED] px-[9px] py-[3px] text-[11px] font-semibold text-[#A84F38] md:px-2.5 md:py-1 md:text-[12px]">
          1 / 6
        </span>
      </div>

      <p className="m-0 mb-1 text-[11px] font-bold tracking-[0.12em] text-[#A84F38] md:text-[12px]">
        예복 활용도
      </p>
      <h3 className="m-0 mb-3.5 text-[17px] font-bold leading-[1.4] tracking-[-0.012em] text-[#17171A] md:mb-[18px] md:text-[19px]">
        신랑님은 평소 정장을
        <br />
        얼마나 자주 입으세요?
      </h3>

      <div className="relative">
        <div className="flex flex-col gap-2">
          {options.map((option) => {
            const selected = option.id === selectedOptionId;

            return (
              <button
                key={option.id}
                type="button"
                tabIndex={-1}
                className={`flex w-full cursor-default items-center gap-2.5 rounded-xl border px-3.5 py-3 text-left font-[inherit] text-[14px] transition-none ${
                  selected
                    ? 'border-[#A84F38] bg-[#FBF1ED] font-semibold text-[#17171A]'
                    : 'border-[rgba(112,115,124,0.22)] bg-white font-medium text-[rgba(46,47,51,0.88)]'
                }`}
              >
                <span
                  className={`h-3.5 w-3.5 flex-shrink-0 rounded-full border-2 ${
                    selected
                      ? 'border-[#A84F38] bg-[#A84F38]'
                      : 'border-[rgba(112,115,124,0.4)] bg-white'
                  }`}
                />
                <span>{option.label}</span>
              </button>
            );
          })}
        </div>
        <div className="absolute inset-0 z-10 bg-transparent" aria-hidden="true" />
      </div>

      <div className="mt-3.5 rounded-xl bg-[#FBF1ED] px-3.5 py-3 md:mt-4 md:px-4 md:py-3.5">
        <p className="m-0 mb-1 text-[10.5px] font-bold tracking-[0.12em] text-[#8E3F2C] md:text-[11px]">
          플래너 피드백
        </p>
        <p className="m-0 text-[13px] font-medium leading-[1.6] text-[#17171A] md:text-[13.5px]">
          &quot;{selectedFeedback}&quot;
        </p>
      </div>

      <Link
        to="/guide/suit"
        className="mt-[18px] hidden text-center text-[14px] font-semibold text-[#A84F38] md:block"
      >
        전체 질문 해보기 →
      </Link>
    </div>
  );
}

export default function MainQuestionSection() {
  return (
    <section className="bg-[#F7F7F8] px-5 py-11 md:px-6 md:py-16 lg:py-24">
      <div className="mx-auto grid max-w-[1200px] gap-8 lg:grid-cols-[minmax(360px,1fr)_minmax(320px,440px)] lg:items-center lg:gap-14">
        <div>
          <span className="text-[12px] font-bold tracking-[0.12em] text-[#A84F38] md:text-[13px]">
            내 취향 찾기
          </span>
          <h2 className="m-0 mt-2.5 text-[24px] font-bold leading-[1.4] tracking-[-0.023em] text-[#17171A] md:mt-3 md:text-[34px] md:leading-[1.35] md:tracking-[-0.025em]">
            공부하지 마세요.
            <br />
            답만 하시면 돼요.
          </h2>
          <p className="m-0 mt-2.5 text-[14.5px] leading-[1.65] text-[rgba(46,47,51,0.61)] md:mt-4 md:max-w-[420px] md:text-[16px]">
            긴 가이드를 읽지 않아도 괜찮아요. 질문에 답하다 보면 내가 중요하게 봐야 할 기준이 자연스럽게 정리됩니다.
          </p>

          <div className="mb-10 mt-6 hidden flex-col gap-5 md:flex">
            {steps.map((step) => (
              <div key={step.number} className="flex items-start gap-4">
                <span className="min-w-7 pt-0.5 text-[15px] font-bold text-[#A84F38]">
                  {step.number}
                </span>
                <div>
                  <p className="m-0 text-[16px] font-semibold text-[#17171A]">{step.title}</p>
                  <p className="m-0 mt-1 text-[14px] text-[rgba(46,47,51,0.61)]">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <Link
            to="/guide"
            className="hidden items-center gap-2 rounded-lg bg-[#17171A] px-[26px] py-3.5 text-[15px] font-semibold text-white transition-opacity hover:text-white hover:opacity-85 md:inline-flex"
          >
            지금 시작하기
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>

        <div>
          <QuestionPreviewCard />
          <Link
            to="/guide"
            className="flex items-center justify-center gap-2 rounded-lg bg-[#17171A] px-0 py-3.5 text-[15px] font-semibold text-white hover:text-white md:hidden"
          >
            지금 시작하기
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>
      </div>
    </section>
  );
}
